import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import { formatDate, formatNumber } from 'wc-lib';

@Component({
  template: require('./cumulative-price-table.html'),
  name: 'cumulative-price-table'
})
export class CumulativePriceTable extends Vue {
  @Prop() data: any[];
  @Prop() pageSize: number;

  maxPages: number = 0;

  sortColumn: string = 'dateTime';
  sortAscending: boolean = false;

  pageNum: number = 1;
  pageNums: number[] = [];
  pageRows: any[] = [];

  created() {
    this.maxPages = Math.ceil(this.data.length / this.pageSize);
    this.setPageNums();
    this.setPageRows();
  }

  changePage(newPageNum: number): void {
    this.pageNum = newPageNum;
    this.setPageNums();
    this.setPageRows();
  }

  sort(column: string, ascending: boolean): void {
    this.sortColumn = column;
    this.sortAscending = ascending;

    this.changePage(1);
  }

  sortActive(column: string, ascending: boolean) {
    return column === this.sortColumn && ascending === this.sortAscending ? 'active' : '';
  }

  setPageNums(): void {
    this.pageNums = [];

    for (let i=1; i<=this.maxPages; i++) {
      if (i === 1
        || i === this.maxPages
        || (i >= this.pageNum-2 && i <= this.pageNum+2)) {
        this.pageNums.push(i);
      }
      else {
        if (this.pageNums.length > 0 && this.pageNums[this.pageNums.length-1] !== -1) {
          this.pageNums.push(-1); // rendered as '...'
        }
      }
    }
  }

  setPageRows(): void {
    let sortedData: any[] = [ ...this.data ];
    if (this.sortAscending) {
      sortedData.sort((a, b) => b[this.sortColumn] - a[this.sortColumn]);
    }
    else
    {
      sortedData.sort((a, b) => a[this.sortColumn] - b[this.sortColumn]);
    }

    this.pageRows = [];
    for (let i = (this.pageNum-1)*this.pageSize; i < Math.min(this.pageNum*this.pageSize, sortedData.length); i++) {
      let row = sortedData[i];
      this.pageRows.push({ 
        dateTime: formatDate(row.dateTime, 'dd/MM/yyyy HH:mm'), 
        nsw: formatNumber(row.NSW1, '$0,00'),
        qld: formatNumber(row.QLD1, '$0,00'),
        vic: formatNumber(row.VIC1, '$0,00'),
        sa: formatNumber(row.SA1, '$0,00'),
        tas: formatNumber(row.TAS1, '$0,00'),
        cpt: formatNumber(row.CPT, '$0,00'),
        type: row.isActual ? 'Actual' : 'Forecast' });
    }
  }
}



// WEBPACK FOOTER //
// src/views/electricity/nem/cumulative-price-table.ts